import React, { useState } from 'react';
import {
  ColorPageSectionHeading,
  FaqAns,
  FaqContainer,
  FaqQues,
} from './styled';
import { colorPageFaqs } from './constant';
import ScrollWrapper from '../ScrollWrapper/ScrollWrapper';
import { getScreenName } from '../../Utils/helper';

const ColorPageFaqs = ({ heading, showHamIcon }) => {
  const [activeFaqs, setActiveFaqs] = useState([0]);
  const handleFaqClick = (idx) => {
    const copy = JSON.parse(JSON.stringify(activeFaqs));
    if (copy.includes(idx)) {
      copy.splice(copy.indexOf(idx), 1);
    } else copy.push(idx);
    setActiveFaqs(copy);
  };
  const impressionData = {
    category: 'impression_section_in_general_screen',
    section_name: 'Frequently Asked Questions',
    screen_name: heading || getScreenName(),
  };
  return (
    <>
      <br />
      <br />
      <ScrollWrapper data={impressionData}>
        <ColorPageSectionHeading faq={true}>
          Frequently Asked Questions
        </ColorPageSectionHeading>
        <br />
        {colorPageFaqs.map((faq, index) => {
          return (
            <FaqContainer key={'colorPageFaq' + index}>
              <FaqQues onClick={() => handleFaqClick(index)}>
                <p>{faq.questionText}</p>
                <img
                  className={activeFaqs.includes(index) ? 'open' : 'closed'}
                  src="https://images.myloapp.in/NestJsUploads/1717756253487-arrow.webp"
                  alt=""
                />
              </FaqQues>
              <FaqAns
                className={
                  activeFaqs.includes(index) ? 'expanded' : 'collapsed'
                }
              >
                {faq.answerText}
              </FaqAns>
            </FaqContainer>
          );
        })}
      </ScrollWrapper>
    </>
  );
};

export default ColorPageFaqs;
